import { ToggleNames } from 'helpers/featureToggle';

export type IEnumToggleProp<R> = { [key in keyof typeof ToggleNames]: R };

export enum EHttpStatusCode {
    OK = 200,
    UNAUTHORIZED = 401,
    FORBIDDEN = 403,
}

export type ErrorResponse = {
    status?: number;
    message: string;
};
